import { IconProps } from '../..';
import { iconStyles } from '../../iconStyles';

export const IconFavourite = (props: IconProps) => (
  <svg
    className={iconStyles(props)}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 27 22"
    width="100%"
  >
    <path
      fillRule="evenodd"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M24.180446 12.718547c-1.427349 1.39859-6.031193 5.412535-10.680327 8.50453-4.64961-3.091995-9.253455-7.10594-10.680327-8.50453-1.787762-1.751799-2.788908-5.922408-.0205-9.194331 1.2214-1.443691 2.79606-2.257399 4.553787-2.354246A6.305523 6.305523 0 017.707771 1.16c1.841633 0 3.686603.78285 5.242194 2.232712.135394.160938.331332.252088.556352.256361.215962-.001424.415714-.10017.548724-.261108 1.651415-1.53864 3.632732-2.323863 5.592118-2.21752 1.757728.096372 3.331912.910555 4.55331 2.35377 2.768886 3.271924 1.767263 7.442533-.020022 9.194332"
    />
  </svg>
);
